import {
  LIBRARY_DISCOUNT_PAGE_REQUEST,
  LIBRARY_DISCOUNT_SET_OUTLETS,
  LIBRARY_DISCOUNT_OUTLETS_REQUEST,
  LIBRARY_DISCOUNT_ON_CHANGE_OUTLET_IDS,
  LIBRARY_DISCOUNT_ON_CLICK_CREATE_DISCOUNT,
  LIBRARY_DISCOUNT_SET_DISCOUNTS,
  LIBRARY_DISCOUNT_ON_CLICK_ROW,
  LIBRARY_DISCOUNT_SET_DISCOUNT_DETAIL,
  LIBRARY_DISCOUNT_DISCOUNTS_REQUEST,
  LIBRARY_DISCOUNT_SET_CURRENT_PAGE,
  LIBRARY_DISCOUNT_SET_TOTAL_PAGE,
  LIBRARY_DISCOUNT_UNSET_DISCOUNT,
  LIBRARY_DISCOUNT_SET_CREATE_DISCOUNT,
  LIBRARY_DISCOUNT_CLEAR_AMOUNT_FIELD,
  LIBRARY_DISCOUNT_SUBMIT_FORM_CREATE,
  LIBRARY_DISCOUNT_SUBMIT_FORM_CREATE_ALL_OUTLET,
  LIBRARY_DISCOUNT_SUBMIT_FORM_UPDATE,
  LIBRARY_DISCOUNT_ASK_DELETE_DISCOUNT,
  LIBRARY_DISCOUNT_DELETE_DISCOUNT,
  LIBRARY_DISCOUNT_CANCEL_DELETE_DISCOUNT,
  LIBRARY_DISCOUNT_SHOW_DELETE_DISCOUNT_MODAL,
  LIBRARY_DISCOUNT_HIDE_DELETE_DISCOUNT_MODAL,
  LIBRARY_DISCOUNT_SET_DELETED_DISCOUNT,
  LIBRARY_DISCOUNT_ON_CLICK_CANCEL,
  LIBRARY_DISCOUNT_IS_SUBMITTING_FORM,
} from './constants';

export function pageRequest() {
  return { type: LIBRARY_DISCOUNT_PAGE_REQUEST, payload: {} };
}

export function setOutlets(outlets) {
  return { type: LIBRARY_DISCOUNT_SET_OUTLETS, payload: { outlets } };
}

export function outletsRequest(params) {
  return { type: LIBRARY_DISCOUNT_OUTLETS_REQUEST, payload: { params } };
}

export function discountsRequest(params, previousDiscounts) {
  return {
    type: LIBRARY_DISCOUNT_DISCOUNTS_REQUEST,
    payload: { params, previousDiscounts },
  };
}

export function onChangeOutletIds(outletIds) {
  return {
    type: LIBRARY_DISCOUNT_ON_CHANGE_OUTLET_IDS,
    payload: { outletIds },
  };
}

export function onClickCreateDiscount() {
  return { type: LIBRARY_DISCOUNT_ON_CLICK_CREATE_DISCOUNT };
}

export function setNewDiscount() {
  return { type: LIBRARY_DISCOUNT_SET_CREATE_DISCOUNT };
}

export function onClickRow(discount) {
  return { type: LIBRARY_DISCOUNT_ON_CLICK_ROW, payload: { discount } };
}

export function setDiscounts(discounts) {
  return { type: LIBRARY_DISCOUNT_SET_DISCOUNTS, payload: { discounts } };
}

export function setDiscountDetail(discount) {
  return { type: LIBRARY_DISCOUNT_SET_DISCOUNT_DETAIL, payload: { discount } };
}

export function unSetDiscountDetail() {
  return { type: LIBRARY_DISCOUNT_UNSET_DISCOUNT, payload: {} };
}

export function clearAmountField() {
  return { type: LIBRARY_DISCOUNT_CLEAR_AMOUNT_FIELD, payload: {} };
}

export function setCurrentPage(currentPage) {
  return { type: LIBRARY_DISCOUNT_SET_CURRENT_PAGE, payload: { currentPage } };
}

export function setTotalPage(totalPage) {
  return { type: LIBRARY_DISCOUNT_SET_TOTAL_PAGE, payload: { totalPage } };
}

export function submitFormCreate(data, previousDiscounts) {
  return {
    type: LIBRARY_DISCOUNT_SUBMIT_FORM_CREATE,
    payload: { data, previousDiscounts },
  };
}

export function submitFormCreateAllOutlet(data, previousDiscounts) {
  return {
    type: LIBRARY_DISCOUNT_SUBMIT_FORM_CREATE_ALL_OUTLET,
    payload: { data, previousDiscounts },
  };
}

export function submitFormUpdate(discountId, data, previousDiscounts) {
  return {
    type: LIBRARY_DISCOUNT_SUBMIT_FORM_UPDATE,
    payload: { discountId, data, previousDiscounts },
  };
}

export function deleteDiscount(discountId, previousDiscounts) {
  return {
    type: LIBRARY_DISCOUNT_DELETE_DISCOUNT,
    payload: { discountId, previousDiscounts },
  };
}

export function cancelDeleteDiscount() {
  return { type: LIBRARY_DISCOUNT_CANCEL_DELETE_DISCOUNT, payload: {} };
}

export function showDeleteDiscountModal() {
  return { type: LIBRARY_DISCOUNT_SHOW_DELETE_DISCOUNT_MODAL, payload: {} };
}

export function hideDeleteDiscountModal() {
  return { type: LIBRARY_DISCOUNT_HIDE_DELETE_DISCOUNT_MODAL, payload: {} };
}

export function setDeletedDiscount(deletedDiscount) {
  return {
    type: LIBRARY_DISCOUNT_SET_DELETED_DISCOUNT,
    payload: { deletedDiscount },
  };
}

export function askDeleteDiscount(deletedDiscount) {
  return {
    type: LIBRARY_DISCOUNT_ASK_DELETE_DISCOUNT,
    payload: { deletedDiscount },
  };
}

export function onClickCancel() {
  return { type: LIBRARY_DISCOUNT_ON_CLICK_CANCEL, payload: {} };
}

export function isSubmittingForm(isSubmittingForm) {
  return {
    type: LIBRARY_DISCOUNT_IS_SUBMITTING_FORM,
    payload: { isSubmittingForm },
  };
}
